module.exports = __webpack_public_path__ + "img/gabon.c948b2bf.png";